export default __webpack_public_path__ + "static/media/2nd.af6c8244.jpg";